import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FullPageLoader } from '@components';
import { NAV_ROUTES } from '@constants/navRoutes';
import UserAuth from '@services/auth';
import { storeDeepLink } from './utils';

const DeepLinkRedirect: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Runs once on mount: the page only stores the link and redirects away.
  useEffect(() => {
    // sessionStorage can throw (quota, storage blocked); losing the deep link is fine, getting
    // stuck on this loader is not.
    let remainingParams = searchParams;
    try {
      remainingParams = storeDeepLink(searchParams);
    } catch (error) {
      console.error('Error storing deep link:', error);
    }

    if (UserAuth.accessToken && UserAuth.refreshToken) {
      navigate(NAV_ROUTES.AUTH, { replace: true });
      return;
    }

    navigate(
      { pathname: NAV_ROUTES.SIGNUP, search: remainingParams.toString() },
      { replace: true },
    );
  }, []);

  return <FullPageLoader />;
};

export default DeepLinkRedirect;
